import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CurrentUserService } from 'src/app/user/services';
import { IdentityService } from '../services/identity.service';
import { IdentityTokenAmountSelectorComponent } from '../identity-tokens/identity-token-amount-selector.component';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { IdentityTokenView } from '../models/identity-token-view';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { IdentityTokenAmountSelectorComponent as IdentityTokenAmountSelectorComponent_1 } from './identity-token-amount-selector.component';
import { DxDataGridModule } from 'devextreme-angular';
import { DxoEditingModule, DxoPopupModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
@Component({
    selector: 'ep-identity-tokens',
    templateUrl: './identity-tokens.component.html',
    styleUrls: ['./identity-tokens.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, IdentityTokenAmountSelectorComponent_1, DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoPopupModule, DxiColumnModule]
})
export class IdentityTokensComponent implements OnInit {

    public tokenview: IdentityTokenView[] = [];

    @ViewChild('identityTokenAmountSelector', { static: true }) private identityTokenAmountSelector: IdentityTokenAmountSelectorComponent;
    @ViewChild(BizDataGridDirective, { static: true }) private datagrid: BizDataGridDirective;

    constructor(
        private identityService: IdentityService,
        private currentUserService: CurrentUserService) {
    }

    async ngOnInit(): Promise<void> {
        this.tokenview = await this.identityService.getTokenViews(this.identityTokenAmountSelector.selectedSearchAmount.value);
        await this.identityTokenAmountSelector.ngOnInit();
    }


    async refresh(): Promise<void> {
        this.tokenview = await this.identityService.getTokenViews(this.identityTokenAmountSelector.selectedSearchAmount.value);
    }



    async identityAmountChanged() {
        this.tokenview = await this.identityService.getTokenViews(this.identityTokenAmountSelector.selectedSearchAmount.value);
   }
}
